/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const TransitionContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LineContainer = styled.div`
  padding-bottom: ${gridSize()}px;
`;

export const WarningContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SelectContainer = styled.div`
  padding-right: ${gridSize() / 4}px;
  padding-left: ${gridSize() / 4}px;
  flex-shrink: 0;
`;

export const IssueContainer = styled.div`
  padding-left: ${gridSize() / 4}px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

export const IssueKeyContainer = styled.div`
  color: ${token('color.text.subtlest', colors.N300)};
  padding-left: ${gridSize()}px;
  padding-right: ${gridSize()}px;
  max-width: ${gridSize() * 14}px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const IssueSummaryContainer = styled.div`
  max-width: ${gridSize() * 29}px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ArrowContainer = styled.div`
  display: flex;
  padding-left: ${gridSize() * 1.5}px;
  padding-right: ${gridSize() / 2}px;
`;

export const TriggerContainer = styled.div`
  margin-left: ${gridSize() / 2}px;
  margin-bottom: ${gridSize() / 8}px;
`;
